export function LoadingSpinner() {
return (
    <div className="p-4 text-center">
        Loading...
    </div>
);
}